import ICO_COOPERATION from '@/assets/images/price/ico-cooperation.png';
import ICO_COPYRIGHT from '@/assets/images/price/ico-copyright.png';
import ICO_FLOWCHART from '@/assets/images/price/ico-flowchart.png';
import ICO_MEETING from '@/assets/images/price/ico-meeting.png';
import ICO_PDF from '@/assets/images/price/ico-pdf.png';
import ICO_SAFE from '@/assets/images/price/ico-safe.png';
import ICO_SPACE from '@/assets/images/price/ico-space.png';
import ICO_DOCKER from '@/assets/images/price/ico-docker.svg';
import ICO_AI from '@/assets/images/price/ico-ai.svg';
import ICO_DEVELOP from '@/assets/images/price/ico-develop.svg';
import { common } from '@/common/constants/config';
import { getBuyPageLink } from '@/common/utils/business';

export const PricePackageList = [
  {
    name: '体验版',
    desc: '协作体验首选',
    price: '0',
    priceLimit: '上限20人',
    priceUnit: '元/人/年',
    tag: 'free',
    event: 'trial_apply_try',
    type: 'wps365_business_trial_abpackage',
    feature: [
      {
        icon: ICO_SPACE,
        text: '基础存储空间（上限10G）',
      },
      {
        icon: ICO_MEETING,
        text: '文档&会议高效协作',
      },
    ],
    mainButtonText: '开始试用',
    mainButtonUrl:
      'https://plus.wps.cn/fab/registerGuide/?utm_source=WPS365_EDU_WEB&utm_medium=price',
  },
  // {
  //   name: '教育基础版',
  //   desc: '适用于全校学生使用的基础工具',
  //   price: '19.9',
  //   priceLimit: '5人起购',
  //   priceUnit: '元/人/年',
  //   event: 'contact_sales_basic',
  //   type: 'wps365_edu_basic',
  //   feature: [
  //     {
  //       icon: ICO_SPACE,
  //       text: '基础存储空间（10G/人）',
  //     },
  //     // {
  //     //   icon: ICO_MEETING,
  //     //   text: '文档&会议高效协作',
  //     // },
  //     {
  //       icon: ICO_COOPERATION,
  //       text: 'WPS协作专业版',
  //     },
  //     {
  //       icon: ICO_SAFE,
  //       text: '团队级安全管控',
  //     },
  //   ],
  //   mainButtonText: '立即购买',
  //   mainButtonUrl: getBuyPageLink({ serviceVal: 'wps365_edu_basic' }),
  // },
  {
    name: '教育标准版',
    desc: '提供正版化授权和基础协作能力',
    price: '199',
    priceLimit: '5人起购',
    priceUnit: '元/人/年',
    tag: 'free',
    event: 'trial_apply_try',
    type: 'wps365_edu_standard',
    feature: [
      {
        icon: ICO_SPACE,
        text: '基础存储空间（50G/人）',
      },
      {
        icon: ICO_COOPERATION,
        text: 'WPS协作专业版',
      },
      {
        icon: ICO_SAFE,
        text: '团队级安全管控',
      },
      {
        icon: ICO_COPYRIGHT,
        text: '正版化授权',
      },
    ],
    mainButtonText: '立即购买',
    mainButtonUrl: getBuyPageLink({ serviceVal: 'wps365_edu_standard' }),
  },
  {
    name: '教育高级版',
    desc: '赋能校内教师/职工日常教学办公',
    price: '299',
    priceLimit: '5人起购',
    priceUnit: '元/人/年',
    tag: '',
    event: 'contact_sales_application',
    type: 'wps365_edu_advanced_twin',
    feature: [
      {
        icon: ICO_SPACE,
        text: '充足存储空间（365G/人）',
      },
      {
        icon: ICO_COOPERATION,
        text: 'WPS协作专业版',
      },
      {
        icon: ICO_FLOWCHART,
        text: 'PDF、图片等多项增值服务',
      },
      {
        icon: ICO_SAFE,
        text: '团队级安全管控',
      },
      {
        icon: ICO_COPYRIGHT,
        text: '正版化授权',
      },
    ],
    mainButtonText: '立即购买',
    mainButtonUrl: getBuyPageLink({ serviceVal: 'wps365_edu_advanced_twin' }),
  },
  // {
  //   name: '教育高级版',
  //   desc: '丰富模版资源，提升教师/职工工作效率',
  //   price: '399',
  //   priceLimit: '5人起购',
  //   priceUnit: '元/人/年',
  //   tag: '',
  //   event: 'contact_sales_basic',
  //   type: 'wps365_edu_advanced_twin',
  //   feature: [
  //     {
  //       icon: ICO_FLOWCHART,
  //       text: '包含应用版全部权益服务',
  //     },
  //     {
  //       icon: ICO_DOCKER,
  //       text: '新增稻壳模版权益',
  //     },
  //     {
  //       icon: ICO_COOPERATION,
  //       text: 'WPS协作专业版',
  //     },
  //     {
  //       icon: ICO_COPYRIGHT,
  //       text: '正版化授权',
  //     },
  //   ],
  //   mainButtonText: '立即购买',
  //   mainButtonUrl: getBuyPageLink({ serviceVal: 'wps365_edu_advanced_twin' }),
  // },
  {
    name: '教育旗舰版',
    desc: 'WPS AI全面助力教育质量提升',
    price: '499',
    priceLimit: '5人起购',
    priceUnit: '元/人/年',
    tag: 'recommend',
    event: 'contact_sales_basic',
    type: 'wps365_edu_flagship_twin',
    feature: [
      {
        icon: ICO_SPACE,
        text: '充足存储空间（2T/人）',
      },
      {
        icon: ICO_COOPERATION,
        text: 'WPS协作专业版',
      },
      {
        icon: ICO_FLOWCHART,
        text: 'PDF、图片等多项增值服务',
      },
      {
        icon: ICO_SAFE,
        text: '团队级安全管控',
      },
      {
        icon: ICO_COPYRIGHT,
        text: '正版化授权',
      },
      // {
      //   icon: ICO_FLOWCHART,
      //   text: '包含应用版全部权益服务',
      // },
      {
        icon: ICO_AI,
        text: '新增WPS AI权益',
      },
      // {
      //   icon: ICO_DEVELOP,
      //   text: '二次开发能力',
      // },
    ],
    mainButtonText: '立即购买',
    mainButtonUrl: getBuyPageLink({ serviceVal: 'wps365_edu_flagship_twin' }),
  },
];

export const priceDetail = [
  {
    name: 'WPS 365 教育版客户端',
    logo: require('@/assets/images/brand/365-client-logo.svg'),
    children: [
      {
        name: 'WPS Office正版授权（含VBA）',
        tip: '构建机构信誉度和合规化',
        children: ['N', 'Windows/Linux二选一', 'Windows/Linux二选一', 'Y'],
      },
      {
        name: '金山文档｜WPS云文档 Web版',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '数科OFD增值权益',
        children: ['N', 'N', 'N', 'N'],
      },
      {
        name: '公文版增值权益',
        children: ['N', 'N', 'N', 'N'],
      },
    ],
  },
  {
    name: '云文档',
    logo: require('@/assets/images/brand/cloud-file-logo.svg'),
    children: [
      {
        name: '存储空间',
        children: ['激活人数*2GB/人（上限10GB）','基础存储空间（50G/人）', '更大存储空间（365G/人）', '充足存储空间（2T/人）'],
      },
      {
        name: '创建团队数量上限',
        tip: '机构成员最多可创建的团队数量',
        children: ['100个/人', '300个/人', '300个/人', '300个/人'],
      },
      {
        name: '团队文档权限自定义设置',
        tip: '支持自由组合团队文件（夹）的查看、下载、编辑、分享、删除等7种权限，实现不同职责的成员拥有不同的文档权限',
        children: ['N', '不限', '不限', '不限'],
      },
      {
        name: '按用户组授权文档权限',
        tip: '可按照成员的岗位或职责来建立「用户组」，对「用户组」授权的文档权限将自动同步给组内所有成员，实现快速授权',
        children: ['N', '不限', '不限', '不限'],
      },
      {
        name: '文件上传大小',
        children: ['10M', '4G', '6G', '10G'],
      },
      {
        name: '文件批量下载数量上限',
        children: ['N', '2000个/次', '2000个/次', '2000个/次'],
      },
      {
        name: '文件批量下载大小上限',
        children: ['N', '10G/次', '10G/次', '10G/次'],
      },
      {
        name: '全文检索',
        tip: '通过匹配正文内容关键词来查找目标文件',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '在线解压',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '在线协同编辑',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '同步文件夹数量上限',
        tip: '设置后，本地文件夹将会同步到云端，可在其他手机、PC设备随时查阅最新文件',
        children: ['1个/人', '10个/人', '10个/人', '10个/人'],
      },
      {
        name: '二级回收站文件恢复时长',
        children: ['最近7天', '不限时长', '不限时长', '不限时长'],
      },
      {
        name: '文档漫游',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '文档批量下载',
        children: ['N', 'Y', 'Y', 'Y'],
      },
    ],
  },
  {
    name: '安全权益',
    logo: require('@/assets/images/brand/security-logo.svg'),
    children: [
      {
        name: '团队文档加密保护',
        tip: '开启后，团队内600M以下Office文档将加密保存为WPS安全格式，仅本团队成员和授权的用户才能打开，文件被下载后，其他人也无法打开',
        tipLink: 'https://www.kdocs.cn/l/sixoONAjzCU2',
        children: ['3个团队/机构', '30个团队/机构', '50个团队/机构', '不限'],
      },
      {
        name: '机构文档水印',
        tip: '支持设置机构的所有成员，在查看机构的文档时显示水印，水印显示为∶成员姓名/WPS 帐号id尾号，可降低主动泄密风险和事后追溯责任人',
        tipLink: 'https://www.kdocs.cn/l/shlvOuDM0ZDj',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '文档分享范围管控（禁止分享到机构/团队外）',
        tip: '开启后，本机构的文档将无法分享到机构外',
        tipLink: 'https://www.kdocs.cn/l/scFLdnSkPSfc',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '团队文档水印',
        tip: '支持设置某团队的所有成员，在查看团队的文档时显示水印，水印显示为∶成员姓名/WPS 帐号id尾号，可降低主动泄密风险和事后追溯责任人',
        tipLink: 'https://www.kdocs.cn/l/skIJILLFdl20',
        children: ['3个团队/机构', '30个团队/机构', '50个团队/机构', '不限'],
      },
      {
        name: '团队文档分享范围管控',
        tip: '可禁止团队文件分享到机构外/团队外',
        tipLink: 'https://www.kdocs.cn/l/sgMLT3SBSbUW',
        children: ['3个团队/机构', '30个团队/机构', '50个团队/机构', '不限'],
      },
      {
        name: '新建团队默认开启【文档加密保护】',
        tip: '管理员可在后台统一设置，防止团队文档因未设置「加密保护」而外泄',
        children: ['N', 'N', 'N', 'N'],
      },
      {
        name: '团队文档分享链接管控范围',
        tip: '支持管控团队文档的分享链接，可随时取消文档的分享链接，避免机密文档被传播',
        tipLink: 'https://www.kdocs.cn/l/skDqhCziuTz4',
        children: ['最近30天', '不限时长', '不限时长', '不限时长'],
      },
      {
        name: '文档流转安全管控（禁止分享到机构/团队外）',
        tip: '开启后，本机构的文档将无法移动或复制到机构外',
        tipLink: 'https://www.kdocs.cn/l/snBWzAAab7Gi',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '机构文档水印样式自定义',
        children: ['N', 'Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '机构文档分享链接管控范围',
        children: ['最近30天', '不限时长', '不限时长', '不限时长'],
      },
      {
        name: 'IP访问限制',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '域名限制（开发中）',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '设备限制（开发中）',
        children: ['N', 'Y', 'Y', 'Y'],
      },
    ],
  },
  {
    name: '机构数字资产管理',
    logo: require('@/assets/images/brand/digital-asset-logo.svg'),
    children: [
      {
        name: '离校师生文档转让',
        tip: '支持一键转让离校师生所有的机构文档给其他成员',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '机构空间自定义分配',
        tip: '支持自定义设置成员和团队的空间使用大小，合理分配空间资源',
        tipLink: 'https://www.kdocs.cn/l/cdb4UuMuPxHW',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: 'AD域账号同步',
        tip: '支持从AD域账号服务同步组织架构信息，域账号数据源调整后可自动同步更新',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '机构成员数量',
        children: ['上限20人', '最少5人起购', '最少5人起购', '最少5人起购'],
      },
      {
        name: '组织架构管理',
        tip: '支持编辑和添加各级部门、成员',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '使用数据概况',
        tip: '支持查看成员、文档、团队、空间的使用情况',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '后台日志追溯时间',
        tip: '支持查看文档、团队、后台、登录等操作日志，追溯所有员工的操作详情',
        children: ['当天', '最近6个月', '最近6个月', '最近1年'],
      },
      {
        name: '成员账户活跃详情',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '团队创建审批管理',
        tip: '开启后，所有成员创建的团队必须经过机构管理员审批通过后才可创建成功',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '变更团队拥有者',
        tip: '支持在后台更换团队拥有者',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '恢复已解散团队',
        tip: '支持恢复已解散的团队，团队内的文档将一同恢复',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '自定义后台管理员操作权限',
        tip: '支持新增和修改拥有指定功能操作权限的管理员，减轻超级管理员管理负担',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '自定义后台管理员部门管控范围',
        tip: '支持按部门设置管理员的成员管控范围，实现管理员仅能查看和管控自己部门成员',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '通讯录可见性自定义设置',
        tip: '支持灵活设置员工仅可见部分组织架构，防止组织架构和人员信息泄密',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '通讯录成员自定义排序',
        tip: '可对同一部门内成员进行自定义排序，支持拖动、置顶等灵活操作模式',
        children: ['N', 'Y', 'Y', 'Y'],
      },
    ],
  },
  {
    name: 'WPS协作：内部沟通更高效',
    logo: require('@/assets/images/brand/woa-logo.svg'),
    children: [
      {
        name: '群组人数上限',
        children: ['N', '上限3000', '上限3000', '上限3000'],
      },
      {
        name: '云端消息存储空间',
        children: ['N', '1T', '1T', '1T'],
      },
      {
        name: '待办',
        tip: '支持给自己添加待办、支持给其他人分配待办',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '日历',
        tip: '支持管理时间和日程安排，快速与同事邀约开会',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '表单',
        tip: '可以使用表单快速收集、统计信息，快速汇总收集结果',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '轻审批',
        tip: '支持创建一站式机构审批流程，快速完成审批和任务流转',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '公告',
        tip: '支持向全员或指定人推送重要信息',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '同事圈',
        tip: '机构师生专属的沟通交流平台',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '工作台创建与管理自建应用',
        tip: '支持创建机构自建应用并在机构工作台中集中展示',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '应用管理后台',
        tip: '支持统一管理机构内的应用',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '消息基础收发',
        tip: '支持在单聊会话、群聊会话中收发文本、图片、图文、视频、文件等基础消息',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '云端消息存储时间',
        children: ['N', '180天', '180天', '180天'],
      },
    ],
  },
  {
    name: 'WPS会议：随时随地高效开会',
    logo: require('@/assets/images/brand/meeting-logo.svg'),
    children: [
      {
        name: '每月可用时长',
        tip: '每月可用总的会议时长，用完后无法创建新的会议。需要完成机构认证才可使用',
        children: ['40分钟/月/人-限免', '200分钟/月/人-限免', '600分钟/月/人', '1200分钟/月/人'],
      },
      {
        name: '单个会议的最长时长',
        tip: '每次会议最长的时间，目前仅在WPS会议客户端入口判断和提示',
        children: [
          '40分钟',
          '40分钟',
          '单个会议最长时长24小时',
          '单个会议最长时长24小时',
        ],
      },
      {
        name: '单个会议支持多少人入会',
        tip: '每场会议最多支持的参会成员，成员已满的话，新参会者无法加入会议',
        children: ['50方', '50方', '50方', '100方'],
      },
      {
        name: '视频美颜',
        tip: '自动调整视频中人物的皮肤颜色、对比度等因素，从而达到美化的效果',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '音频AI降噪',
        tip: '减少或消除音频信号中的噪声，使其更加清晰',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '切换布局（三种视图）',
        tip: '变更会议界面的内容元素展示',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '共享文档协作',
        tip: '将文档作为共享内容，参会成员可边开会，边协同编辑',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '共享屏幕',
        tip: '将自己屏幕或应用窗口作为内容共享给其他参会成员查看',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '指定会议主持人',
        tip: '将会议中某位成员设为主持人',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '共享权限控制',
        tip: '设置共享文档的权限',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '指定机构参会者',
        tip: '创建新会议时，可从机构通讯录中快速邀请参会成员',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      // {
      //   name: '共享屏幕标注',
      //   children: ['Y', 'Y', 'Y'],
      // },
      // {
      //   name: '锁定会议',
      //   children: ['Y', 'Y', 'Y'],
      // },
      // {
      //   name: '导出参会人员',
      //   children: ['Y', 'Y', 'Y'],
      // },
    ],
  },
  {
    name: 'WPS邮箱',
    logo: require('@/assets/images/brand/mail.png'),
    children: [
      {
        name: '邮件代收',
        tip: '提供第三方邮件服务代收的基础功能',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '邮件审核',
        tip: '管理员设置邮件规则过滤，进行邮件审核',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '邮件归档',
        tip: '邮箱归档系统',
        children: ['N', 'Y', 'Y', 'Y'],
      },
      {
        name: '邮件撤回',
        tip: '管理员/发送者撤回已发送的邮件',
        children: ['N', 'Y', 'Y', 'Y'],
      },
    ],
  },
  {
    name: 'WPS AI',
    logo: require('@/assets/images/brand/ai.png'),
    children: [
      {
        name: 'AI写公式',
        tip: '无需记函数和各种操作技巧，发出命令，AI一键写公式',
        children: ['N', 'N', 'N', 'Y'],
      },
      {
        name: 'AI一键生成PPT',
        tip: '含主题生成PPT和文档生成PPT，一句话简单描述，生成整份PPT',
        children: ['N', 'N', 'N', 'Y'],
      },
      {
        name: 'AI写文章',
        tip: '用AI即可快速完成教案、学案、汇报…各类文章起草',
        children: ['N', 'N', 'N', 'Y'],
      },
      {
        name: 'AI智能问答',
        tip: '发布清晰具体的指令和明确的场景，AI快速且准确的回复问题',
        children: ['N', 'N', 'N', 'Y'],
      },
      {
        name: 'AI文档总结',
        tip: '用AI总结超长文档，快速获取关键信息',
        children: ['N', 'N', 'N', 'Y'],
      },
      {
        name: 'AI改写',
        tip: '含AI续写、润色、扩写、缩写功能，满足各种写作要求',
        children: ['N', 'N', 'N', 'Y'],
      },
      {
        name: 'AI灵感市集',
        tip: '发现更多内容创作灵感，用AI生成各种场景的内容文档',
        children: ['N', 'N', 'N', 'Y'],
      },
    ],
  },
  {
    name: '二次开发能力',
    logo: require('@/assets/images/brand/secondary-dev-logo.svg'),
    children: [
      {
        name: '机构文档二次开发接口',
        tip: '开放给机构对团队文档的操作接口，如：创建、移动、复制、上传、更新、下载等',
        children: ['N', 'N', 'Y', 'Y'],
      },
      {
        name: '通讯录管理能力',
        tip: '第三方系统已经存在自己的账户体系和组织架构，可通过三方账户同步服务，将第三方系统的通讯录组织架构同步到金山文档｜WPS云文档中。同时金山文档｜WPS云文档能够基于第三方系统的认证配置，使用第三方系统既有账户登录金山文档｜WPS云文档',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '通讯录可见性设置能力',
        tip: '开放设置成员仅可见部分机构组织架构的能力',
        children: ['N', 'N', 'Y', 'Y'],
      },
      {
        name: '创建团队审批能力',
        tip: '开放获取成员申请创建团队的列表和对申请进行审批的能力。可对接到机构工单系统，满足管理员出于安全管控或团队数量管控，而对机构成员创建团队进行审核的需求',
        children: ['N', 'N', 'Y', 'Y'],
      },
      {
        name: '团队管理能力',
        tip: '开放团队管理能力，可创建团队，向团队添加成员，并设置团队角色，团队包括企业团队与部门团队',
        children: ['N', 'N', 'Y', 'Y'],
      },
      {
        name: '团队权限设置能力',
        tip: '开放对团队文档权限进行自定义设置和给文档进行授权的能力',
        children: ['N', 'N', 'Y', 'Y'],
      },
      {
        name: '机构空间管理能力',
        tip: '开放获取机构、团队、用户空间使用情况的能力，和给团队、用户配置空间使用上限的能力。满足机构管理员对机构空间管理和分配的需求',
        children: ['N', 'N', 'Y', 'Y'],
      },
      {
        name: '客户端二次开放接口',
        children: ['Y', 'Y', 'Y', 'Y'],
      },
      {
        name: '机构日志审计能力',
        tip: '开放日志审计能力，支持查询机构用户对文件（包括文件(夹)管理、分享链接、回收站等）、团队（团队管理&设置、成员管理、权限设置等）、后台（部门&帐号管理、角色管理、系统设置等）及登录（登录时间、登录设备、IP地址等）的操作记录',
        children: ['N', 'N', 'Y', 'Y'],
      },
      {
        name: '更新用户日程能力',
        tip: '开放管理机构成员日程的能力，包含：新建日程、删除日程、修改日程、添加日程成员、删除日程成员、查询人员忙闲的接口',
        children: ['N', 'N', 'Y', 'Y'],
      },
    ],
  },
  {
    name: 'WPS增值特权',
    logo: require('@/assets/images/brand/appreciation-logo.svg'),
    children: [
      {
        name: '脑图流程图教育特权包',
        children: ['加价购', '加价购', 'Y', 'Y'],
        link: 'https://kdocs.cn/l/crS6tYZOv42y',
      },
      {
        name: '图片教育特权包',
        children: ['加价购', '加价购', 'Y', 'Y'],
        link: 'https://kdocs.cn/l/coDCvHLppnmG',
      },
      {
        name: 'PDF教育特权包',
        children: ['加价购', '加价购', 'Y', 'Y'],
        link: 'https://kdocs.cn/l/cgcJtQvixzwJ',
      },
      {
        name: '表格组件增值权益',
        children: ['加价购', '加价购', 'Y', 'Y'],
        link: 'https://kdocs.cn/l/cmr7dvvDtEYk',
      },
      {
        name: '独立功能教育权益包',
        children: ['加价购', '加价购', 'Y', 'Y'],
        link: 'https://kdocs.cn/l/cnZ66tdLYYOM',
      },
      {
        name: '文档恢复教育特权包',
        children: ['加价购', '加价购', 'Y', 'Y'],
        link: 'https://kdocs.cn/l/ceL7KU834tWV',
      },
      {
        name: '云教育特权包',
        children: ['加价购', '加价购', 'Y', 'Y'],
        link: 'https://kdocs.cn/l/cgcJtQvixzwJ',
      },
      // {
      //   name: '美化机构特权包',
      //   children: ['加价购', '加价购', '加价购'],
      // },
      {
        name: '素材教育特权包',
        children: ['加价购', '加价购', '加价购', '加价购'], 
        link: 'https://kdocs.cn/l/cnCMJnctSNJQ',
      },
      {
        name: '模板库教育特权包',
        children: ['加价购', '加价购', '加价购', '加价购'],
        link: 'https://kdocs.cn/l/clAGBJD7aCTB',
      },
    ],
  },
  {
    name: 'Weboffice',
    logo: require('@/assets/images/brand/weboffice-logo.svg'),
    children: [
      {
        name: '并发数',
        tip: '指单应用单日同一时间点可打开的不同文档的最大数量，如需更多数量可联系销售采购',
        children: ['N', '10个', '10个', '20个'],
      },
      {
        name: '单个文档最大尺寸',
        tip: '指应用可打开的单个文档最大尺寸，如需更大尺寸可联系销售采购',
        children: ['N', '10M', '10M', '20M'],
      },
    ],
  },
  {
    name: '业务应用',
    logo: require('@/assets/images/brand/business-logo.svg'),
    children: [
      {
        name: '电子签产品',
        children: ['加价购', '加价购', '加价购', '加价购'],
      },
      {
        name: '金山快搭',
        children: ['加价购', '加价购', '加价购', '加价购'],
      },
    ],
  },
  {
    name: '增值服务',
    logo: require('@/assets/images/brand/appreciation-service-logo.svg'),
    children: [
      {
        name: 'KOS办公技能认证',
        children: ['加价购', '加价购', '加价购', '加价购'],
      },
    ],
  },
  {
    name: '客户服务',
    logo: require('@/assets/images/brand/customer-service-logo.svg'),
    children: [
      {
        name: '人工客服',
        children: ['N', '5*8在线人工客服', '5*8在线人工客服', '5*8在线人工客服'],
      },
      {
        name: '技术支持',
        children: ['N', 'N', '在线+远程', '在线+远程'],
      },
      {
        name: '驻场支持',
        children: ['N', 'N', '联系销售', '联系销售'],
      },
      {
        name: '培训',
        children: ['N', 'N', '联系销售', '联系销售'],
      },
      {
        name: '二次开发服务',
        children: ['N', 'N', '联系销售', '联系销售'],
      },
      {
        name: '账号集成对接',
        children: ['N', 'N', '联系销售', '联系销售'],
      },
    ],
  },

  // '业务应用':{
  //   '电子签产品':['加价购', '加价购', '加价购'],
  //   '金山快搭':['加价购', '加价购', '加价购'],
  // },
  // '增值服务':{
  //   'KOS办公技能认证': ['加价购', '加价购', '加价购'],
  // },
  // '客户服务':{
  //   '人工客服':['5*8在线人工客服','5*8在线人工客服','5*8在线人工客服'],
  //   '技术支持':['在线+远程','N','在线+远程'],
  //   '驻场支持':['联系销售','N', '联系销售'],
  //   '培训': ['联系销售','N', '联系销售'],
  //   '二次开发服务':['联系销售','N', '联系销售'],
  //   '账号集成对接':['联系销售','N', '联系销售'],
  // },
];
